import { render, staticRenderFns } from "./particularSR.vue?vue&type=template&id=744ff66c&"
import script from "./particularSR.vue?vue&type=script&lang=js&"
export * from "./particularSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports